import { Menu, MenuItem } from '@mui/material';

export default function GenerMenuOptions({hoveredItem,hoveredIndex,menuAnchorEl,menuPosition,handleMenuAction,handleMenuClose }) {

    //console.log("hoveredIndex : ",hoveredIndex)
    {/* Dropdown Menu */}
    return (
      <Menu
      anchorEl={menuAnchorEl}
      open={Boolean(menuAnchorEl)}
      onClose={handleMenuClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      anchorReference="anchorPosition"
      anchorPosition={
        menuPosition !== null
          ? { top: menuPosition.mouseY, left: menuPosition.mouseX }
          : undefined
      }
    >
      <MenuItem onClick={() => {
        console.log("edit  : ",hoveredIndex)
        handleMenuAction('edit',hoveredIndex,hoveredItem)
      }}>Edit</MenuItem>
      {hoveredItem?.status === 'deactivated' && <MenuItem onClick={() => {handleMenuAction('remove',hoveredIndex,hoveredItem)}}>Remove</MenuItem>}
      {hoveredItem?.status === 'deactivated' && <MenuItem onClick={() => {handleMenuAction('activate',hoveredIndex,hoveredItem)}}>Activate</MenuItem>}
      {hoveredItem?.status === 'active' && <MenuItem onClick={() => {handleMenuAction('deactivate',hoveredIndex,hoveredItem)}}>Deactivate</MenuItem>}
    </Menu>
    );
  }